
import ProductCategories from '@/graphql/queries/taxonomies/ProductCategories'

export default {
  props: {
    exclude: {
      type: String,
      default: null
    }
  },
  vessel: {
    title: {
      fontSize: '3xl',
      textColor: 'black'
    }
  },
  watch: {
    exclude: '$fetch'
  },
  async fetch() {
    const { data } = await this.$grahql.query({
      clientId: 'eshop',
      query: ProductCategories,
      variables: {
        where: { kind: 'category' },
        children: { activeProducts_is_null: false, name_not: this.exclude }
      }
    })

    this.categories = data.categories.nodes
  },
  data() {
    return {
      categories: null
    }
  },
  computed: {
    buttonAttrs() {
      return {
        color: 'black',
        fontSize: 'lg',
        padding: 'sm'
      }
    }
  }
}
